import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BookOpenCheck, Shield, Heart } from "lucide-react";

export default function Footer() {
  const { user } = useAuth();
  const isAdmin = user && user !== false && user.role === "admin";
  return (
    <footer className="mt-16 border-t border-[#EBDCD1] bg-[#FFFBF5]/80 print:hidden" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="text-xs text-[#857163] flex items-center gap-1.5">
          Made with <Heart className="w-3.5 h-3.5 fill-[#FF7E67] text-[#FF7E67]" /> for cake pop bakers
        </div>
        <nav className="flex items-center gap-4 text-sm">
          <Link
            to="/rules"
            className="text-[#3B2C24] hover:text-[#FF7E67] transition flex items-center gap-1.5"
            data-testid="footer-rules-link"
          >
            <BookOpenCheck className="w-3.5 h-3.5" /> House Rules
          </Link>
          {isAdmin && (
            <Link
              to="/admin"
              className="text-[#3B2C24] hover:text-[#FF7E67] transition flex items-center gap-1.5"
              data-testid="footer-admin-link"
            >
              <Shield className="w-3.5 h-3.5" /> Admin
            </Link>
          )}
          <span className="text-[#857163] hidden sm:inline">Cake Pop Talk © {new Date().getFullYear()}</span>
        </nav>
      </div>
    </footer>
  );
}
